export enum Download_Log_CCP {
    D_FILE_MANAGERC = 1,
    D_LAST_VA_IN_FM = 2,
    D_SPECIFIC_TASK = 3,
    D_REPORT_STRUCT = 4,
    D_REPORT_LISTIN = 5,
    D_FILE_ADSEARCH = 6,
    D_VERSION_HISTO = 7,
    D_LAST_VERSIONA = 8
}

export enum Report_Download {
    PDF = 1,
    XSLX = 2
}
